import { WithTranslation, withTranslation } from 'react-i18next';

import styles from './edit-card-modal.module.css';

import { EditTool } from '../../../UploadDocumentPage/editTool';
import { ModalContainer } from '../../../../../components/ModalContainer';
import { Side } from '../../../../../utils/enum';

interface EditCardModalProps extends WithTranslation {
  currentSide: Side;
  picture: Blob;
  onSave: (picture: Blob) => void;
  onClose: () => void;
  onDismiss: () => void;
}

const EditCardModal = ({
  currentSide,
  picture,
  onSave,
  onClose,
  onDismiss,
  t,
}: EditCardModalProps) => {
  return (
    <ModalContainer
      isOpen={true}
      noPadding={true}
      isDarkMode={true}
      contentClassName={styles.content}
      childrenContainerClassName={styles.childrenContainer}
      topLabel={t(currentSide === Side.Front ? 'frontOfCard' : 'backOfCard')}
      onModalClose={() => {
        onClose();
        onDismiss();
      }}
    >
      <EditTool
        onSave={(picture) => {
          onSave(picture);
          onClose();
        }}
        file={picture}
        continueLabel={t(
          currentSide === Side.Front ? 'saveFrontPhoto' : 'saveBackPhoto',
        )}
        rotateLabel={t('straighten')}
        useNucleusComponents
      />
    </ModalContainer>
  );
};

export default withTranslation('uploadCard')(EditCardModal);
